import React from 'react';

import { CardCvcElement } from '@stripe/react-stripe-js';
import type { StripeCardCvcElementChangeEvent } from '@stripe/stripe-js';

type Props = {
	onChange?: (event: StripeCardCvcElementChangeEvent) => unknown;
};

export function CardCvcElementWrapper({ onChange }: Props): React.JSX.Element {
	return <CardCvcElement options={{ style: { base: { fontSize: '16px' } } }} onChange={onChange} />;
}
